import { usePlan, PLAN_LABELS, PLAN_PRICES, PLAN_FEATURES, PLAN_CURRENCY } from '../hooks/usePlan';

const GOLD    = "#C9A96E";
const INK     = "#1C1915";
const BORDER  = "#E7E1D8";
const SOFT_BG = "#F7F5F2";

export default function PlanGate({ requiredPlan, children, featureName }) {
  const { hasAccess, loading, plan } = usePlan();

  if (loading) return (
    <div style={{ padding: 40, textAlign: "center", color: "#bbb", fontSize: 13 }}>
      Chargement...
    </div>
  );

  if (hasAccess(requiredPlan)) return children;

  // Mur d'upgrade
  return (
    <div style={{
      minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
    }}>
      <div style={{ maxWidth: 680, width: "100%", textAlign: "center" }}>

        {/* Icône cadenas */}
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔒</div>

        <div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 8 }}>
          Accès restreint
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: INK, marginBottom: 8 }}>
          {featureName || "Cette fonctionnalité"} est réservée au forfait{" "}
          <span style={{ color: GOLD }}>{PLAN_LABELS[requiredPlan]}</span>
        </div>
        <div style={{ fontSize: 14, color: "#888", marginBottom: 32 }}>
          Vous êtes actuellement sur le forfait <strong>{PLAN_LABELS[plan]}</strong>.
          Passez à un forfait supérieur pour débloquer cette fonctionnalité.
        </div>

        {/* Cards forfaits */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 14, marginBottom: 28 }}>
          {['starter', 'pro', 'expert', 'lifetime'].map(p => {
            const isRequired = p === requiredPlan;
            const features = PLAN_FEATURES[p];
            const isLifetime = p === 'lifetime';
            return (
              <div key={p} style={{
                background: isRequired ? INK : SOFT_BG,
                border: `2px solid ${isRequired ? GOLD : BORDER}`,
                borderRadius: 12, padding: "20px 18px",
                color: isRequired ? "#fff" : INK,
                transform: isRequired ? "scale(1.03)" : "scale(1)",
                transition: "transform 0.2s",
              }}>
                {isRequired && (
                  <div style={{ fontSize: 9, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 6, fontWeight: 700 }}>
                    ★ Recommandé
                  </div>
                )}
                {isLifetime && !isRequired && (
                  <div style={{ fontSize: 9, letterSpacing: "0.12em", textTransform: "uppercase", color: GOLD, marginBottom: 6, fontWeight: 700 }}>
                    ♾ Accès à vie
                  </div>
                )}
                <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{PLAN_LABELS[p]}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: GOLD, marginBottom: 14 }}>
                  {PLAN_PRICES[p].toLocaleString("fr-FR")}{PLAN_CURRENCY}
                  <span style={{ fontSize: 12, fontWeight: 400, color: isRequired ? "#ccc" : "#999" }}>
                    {isLifetime ? " unique" : "/mois"}
                  </span>
                </div>
                <div style={{ textAlign: "left" }}>
                  {features.map((f, i) => (
                    <div key={i} style={{ fontSize: 12, marginBottom: 6, display: "flex", alignItems: "flex-start", gap: 6 }}>
                      <span style={{ color: GOLD, marginTop: 1 }}>✓</span>
                      <span style={{ color: isRequired ? "#ddd" : "#555" }}>{f}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div style={{ fontSize: 13, color: "#999" }}>
          Pour passer à un forfait supérieur, contactez-nous :{" "}
          <a href="mailto:contact@yoma.design" style={{ color: GOLD, fontWeight: 600 }}>
            contact@yoma.design
          </a>
        </div>
      </div>
    </div>
  );
}
